import { Ability } from 'ember-can';

export default class ProfileAbility extends Ability {
  // Getter and setter
  get canRead() {
    return true;
  }
}
